import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

const WhatsAppFloat = () => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 500);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.a
                    data-testid={LANDING.floatWhatsapp}
                    initial={{ opacity: 0, scale: 0.7, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.7, y: 20 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    href="https://wa.me/573158475169?text=Hola%20Incubatour%2C%20quiero%20conocer%20la%20Misi%C3%B3n%20FITUR%202027"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fixed bottom-6 right-6 z-40 group inline-flex items-center gap-3 rounded-full border border-white/15 bg-black/70 backdrop-blur-xl py-3 pl-4 pr-5 text-[11px] uppercase tracking-[0.22em] text-white hover:border-[color:var(--magenta)]"
                    style={{ boxShadow: '0 24px 60px -16px rgba(0,0,0,0.6)' }}
                >
                    <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--magenta)]">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.762-1.653-2.06-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="white" />
                            <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.143 1.594 5.945L0 24l6.335-1.652a11.882 11.882 0 005.7 1.447h.005c6.585 0 11.946-5.336 11.949-11.896 0-3.181-1.24-6.165-3.49-8.407zm-8.475 18.297h-.004a9.86 9.86 0 01-5.031-1.378l-.361-.214-3.741.975 1.005-3.646-.235-.374a9.86 9.86 0 01-1.51-5.26c.003-5.45 4.437-9.884 9.881-9.884 2.64 0 5.122 1.03 6.988 2.898a9.828 9.828 0 012.893 6.996c-.003 5.451-4.437 9.887-9.885 9.887z" fill="white" />
                        </svg>
                    </span>
                    <span className="hidden md:inline">Habla con la Tribu</span>
                </motion.a>
            )}
        </AnimatePresence>
    );
};

export default WhatsAppFloat;
